import ModalBannedUsers from './modalBannedUsers';

export default ModalBannedUsers;
